// extracted by mini-css-extract-plugin
export default {"root":"ErrorNotify_root__dKLb0","layout-container":"ErrorNotify_layout-container__EKfgt","content":"ErrorNotify_content__irblf","subError":"ErrorNotify_subError__wTiZl","button":"ErrorNotify_button__Ac3Sm","text":"ErrorNotify_text__Nf0S2","buttonClose":"ErrorNotify_buttonClose__7piRa"};
    if(module.hot) {
      // 1763464084350
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  